import { doc, getDoc, Timestamp } from 'firebase/firestore';
import { useCallback, useEffect, useState } from 'react';
import { db } from '../utils/firebase';

export function useCompanyLocationOverride(id) {
  const [override, setOverride] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  const reload = useCallback(() => {
    setReloadToken((currentToken) => currentToken + 1);
  }, []);

  useEffect(() => {
    let cancelled = false;

    const getOverride = async () => {
      setIsLoading(true);
      setError(null);
      setOverride(null);

      try {
        const overrideDocRef = doc(db, 'breweryOverrides', id);
        const overrideDocSnapshot = await getDoc(overrideDocRef);
        const overrideData = overrideDocSnapshot.data();

        if (cancelled) {
          return;
        }

        if (!overrideData) {
          setOverride({});
          return;
        }

        const item = {};
        for (const field in overrideData) {
          if (Object.prototype.hasOwnProperty.call(overrideData, field)) {
            const value = overrideData[field] instanceof Timestamp
              ? overrideData[field].toDate()
              : overrideData[field];
            item[field] = value;
          }
        }

        setOverride(item);
      } catch (readError) {
        if (!cancelled) {
          setError(readError);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    getOverride();

    return () => {
      cancelled = true;
    };
  }, [id, reloadToken]);

  return { override, isLoading, error, reload };
}

export default useCompanyLocationOverride;
